import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastMessage, ToastService } from '../../../core/service/toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  standalone: false,
})
export class ToastComponent implements OnInit, OnDestroy {
  toasts: ToastMessage[] = [];
  private subscription: Subscription = new Subscription();
  private timeouts: Map<string, any> = new Map();

  constructor(
    private toastService: ToastService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.subscription = this.toastService.toast$.subscribe((toast) => {
      // Defer the DOM mutation to the next microtask so it never runs inside an
      // ongoing Angular CD pass — prevents NG0100 when a toast fires mid-check.
      Promise.resolve().then(() => {
        this.toasts.push(toast);
        this.cdr.detectChanges();

        const timeout = setTimeout(() => {
          this.removeToast(toast);
        }, toast.duration || 5000);

        this.timeouts.set(toast.id, timeout);
      });
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    // Clear all timeouts
    this.timeouts.forEach((timeout) => clearTimeout(timeout));
    this.timeouts.clear();
  }

  removeToast(toastToRemove: ToastMessage) {
    // Clear the timeout if it exists
    const timeout = this.timeouts.get(toastToRemove.id);
    if (timeout) {
      clearTimeout(timeout);
      this.timeouts.delete(toastToRemove.id);
    }

    // Remove from display
    this.toasts = this.toasts.filter((toast) => toast.id !== toastToRemove.id);

    // Notify service
    this.toastService.removeToast(toastToRemove.id);
  }

  trackByFn(index: number, item: ToastMessage): string {
    return item.id;
  }

  getToastClass(type: string): string {
    switch (type) {
      case 'success':
        return 'toast show toast-success';
      case 'error':
        return 'toast show toast-error';
      case 'warning':
        return 'toast show toast-warning';
      case 'info':
        return 'toast show toast-info';
      default:
        return 'toast show';
    }
  }

  getIconClass(type: string): string {
    switch (type) {
      case 'success':
        return 'fas fa-check-circle';
      case 'error':
        return 'fas fa-exclamation-circle';
      case 'warning':
        return 'fas fa-exclamation-triangle';
      case 'info':
        return 'fas fa-info-circle';
      default:
        return 'fas fa-bell';
    }
  }

  getTitle(type: string): string {
    switch (type) {
      case 'success':
        return 'Success';
      case 'error':
        return 'Error';
      case 'warning':
        return 'Warning';
      case 'info':
        return 'Information';
      default:
        return 'Notification';
    }
  }
}
